import bugsnag from 'bugsnag-js';
import bugsnagVue from 'bugsnag-vue';

setTimeout(() => {
  global.bugsnagClient = bugsnag({
    autoCaptureSessions: true,
    notifyReleaseStages: $('meta[name="bugsnag-release-stages"]').attr('content').split(','),
    apiKey: $('meta[name="bugsnag-key"]').attr('content'),
    appVersion: $('meta[name="bugsnag-version"]').attr('content'),
    releaseStage: $('meta[name="bugsnag-environment"]').attr('content')
  });

  bugsnagClient.use(bugsnagVue(Vue));
}, 0);